import './App.scss';

import { useState } from 'react';
// import { styles } from './App.scss';

import { GeoJsonDataProvider } from './GeoJsonDataContext';
import { DataLoaderHelper } from './DataLoaderHelper';

import { Tabs, Tab } from 'react-bootstrap';

import NswMasthead from './components/Nsw/NswMasthead';
import NswSiteHeader from './components/Nsw/NswSiteHeader';
import NswHeroBanner from './components/Nsw/NswHeroBanner';
import IntroContent from './components/Nsw/IntroContent';
import NswCards from './components/Nsw/NswCards';
import NswFooter from './components/Nsw/NswFooter';
import './components/Nsw/nsw-overrides.css';
import Header from './components/Header/Header';
import Map from './components/Map/Map';
import Table from './components/Table/Table';

/**
 * App shell: provides GeoJsonData context to the tree, kicks off the data
 * fetch/transform via DataLoaderHelper, and switches between the Map and
 * Table views. Map/Table are only mounted while their tab is active, so
 * they're true mount/unmount boundaries rather than hidden panes.
 */
function App() {

  const [activeTab, setActiveTab] = useState('map');

  return (
    <GeoJsonDataProvider>
      <DataLoaderHelper />
      <NswMasthead />
      <NswSiteHeader />
      <NswHeroBanner />
      <IntroContent />
      <div id="wtd2023InteractiveMap" className="App">
        <Header />
        <Tabs
          id="controlled-tab"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
        >
          <Tab eventKey="map" title="Map">
            {activeTab === 'map' && <Map />}
          </Tab>
          <Tab eventKey="table" title="Table">
            {activeTab === 'table' && <Table />}
          </Tab>
        </Tabs>
      </div>
      <NswCards />
      <NswFooter />
    </GeoJsonDataProvider>
  );
}

export default App;
